import { selectWarehouses } from 'containers/Warehouses/warehousesSlice'
import Warehouse from 'containers/Warehouses/WarehouseComponent'
import useWarehousesLoading from 'hooks/useWarehousesLoading'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Loading from 'components/Loading'
import { useReduxSelector } from 'store'
import './style.scss'

const Warehouses = () => {
  const isLoading = useWarehousesLoading()
  const warehouses = useReduxSelector(selectWarehouses)

  const { push, location: { pathname } } = useHistory()
  const { t } = useTranslation('warehouse')

  return (
    <div className='desktopWarehouses'>
      <div className='title'>
        <div>{t('myWarehouses')}</div>
        <div>{t('selectAWarehouseToManage')}</div>
      </div>

      <div className='desktopWarehouses__grid'>
        {(warehouses?.length > 0 || !isLoading)
          ? warehouses.map(({ objectId, name, acronym, inFuture, dateFrom, doorState, typeName, placeAddress, isShared }) =>
            <div
              key={objectId}
              className='item'
              onClick={() => push(`${pathname}/${objectId}`)}>
              <div className='item__img'>
                <Warehouse
                  inFuture={inFuture}
                  dateFrom={dateFrom}
                  doorState={doorState}
                />
              </div>
              <div className='item__desc'>
                <h2>{typeName + ' (nr.' + name + ')'}</h2>
                <span>{placeAddress}</span>
                {isShared && <span className='shared'><i className='icon icon--share'></i>Udostępniony od: {acronym}</span>}
              </div>
            </div>)
          : <Loading middleOfPage />}
      </div>
    </div>
  )
}

export default Warehouses